<template>
    <div class="content-ficha-editor">
        <div class="editor-header">
            <el-dropdown v-if="editor.type" trigger="click" @command="setDropdownEditor">
                <span class="el-dropdown-link">
                   {{`Editando ${lang[editor.type]}`}}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item 
                    v-for="(option, o) in Object.keys(lang).filter(f => f !== editor.type)" 
                    :key="o"
                    :command="option">
                        {{`Editar ${lang[option]}`}}
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <p v-else>Panel de edición</p>
        </div>

		<div class="editor-body">
            <div v-if="form">
                <el-form label-position="top">
                    <template v-for="(input, i) in form">
                        <template v-if="Array.isArray(input)">
                            <template v-if=" input.every(i => i.cols && i.elementos)">
                                <el-form-item
                                    v-for="(iptcol,c) in input"
                                    :key="c"
                                    :label="`Nº columnas: ${Object.keys(iptcol.elementos).toString()}`">
                                        <el-input-number size="small" v-model="iptcol.cols" style="width: 100%"/>
                                </el-form-item>
                            </template>
                        </template>
                        <template v-else>
                            <template v-if="input && typeof input === 'object'">
                                <template v-for="(prop, p) in input">
                                    <el-form-item
                                        v-if="typeof form[i][p] !== 'object'"
                                        :key="p"
                                        :label="p">
                                            <el-input-number size="small" v-if="typeof form[i][p] === 'number'" :disabled="['id','key','value','tipo'].includes(i)" v-model="form[i][p]" style="width: 100%"/>
                                            <el-switch v-else-if="typeof form[i][p] === 'boolean'"v-model="form[i][p]"/>
                                            <el-input size="small" v-else v-model="form[i][p]" :disabled="['id','key','value','tipo'].includes(i)"/>
                                    </el-form-item>
                                </template>
                            </template>
                            <el-form-item
                                v-else
                                :key="i"
                                :label="i">
                                    <el-input-number size="small" v-if="typeof form[i] === 'number'" :disabled="['id','key','value'].includes(i)" v-model="form[i]" style="width: 100%"/>
                                    <el-switch v-else-if="typeof form[i] === 'boolean'"v-model="form[i]"/>
                                    <el-input size="small" v-else v-model="form[i]" :disabled="['id','key','value','tipo'].includes(i)"/>
                            </el-form-item>
                        </template>
                    </template>
                </el-form>
            </div>
            <div v-else-if="editor.type" class="editor-body-empty">
                <p>Selecciona un componente</p>
            </div>
            <div v-else class="editor-body-empty">
                <p>Selecciona que tipo de elemento quieres editar</p>
                <el-button @click="setEditorType('data')">Inputs</el-button>
                <el-button @click="setEditorType('porlet')">Porlets</el-button>
                <el-button @click="setEditorType('row')">Secciones</el-button>
            </div>
        </div>

        <div class="editor-footer" v-if="form">
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelEditor()">Cancelar</el-button>
                <el-button icon="el-icon-view" @click="previewEditor()"></el-button> <!-- Mostrar boton si hay preview -->
                <el-button type="primary" icon="el-icon-finished" @click="saveEditor()"></el-button>
            </span>
        </div>
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex'
	export default {
		name: 'EditorPanel',
		data () {
			return {
                form: null,
                lang: {
                    data: 'inputs',
                    porlet: 'porlets',
                    row: 'secciones'
                }
            }
        },
        computed: {
            ...mapState({
                editor: state => state.editor
            })
        },
        watch: {
            'editor.form'(val) {
                this.form = JSON.parse(JSON.stringify(val))
            }
        },
        methods: {
            ...mapMutations([
                'setEditorPreview',
                'setEditorCancel',
                'setEditorType'
            ]),
            setDropdownEditor(val) {
                this.setEditorType(val)
            },
            cancelEditor() {
                this.$emit('setFichaFromEditor', this.editor.backup) // Actualizar ficha con backup
                this.setEditorCancel()
            },
            previewEditor() {
                this.setEditorPreview(this.form)
                this.$emit('setFichaFromEditor', this.editor.preview) // Actualizar ficha con preview
            },
            saveEditor() {
                console.log('guardar!')
            }
        }
	}
</script>

<style lang="scss">
.content-ficha-editor {
    background-color: white;
    width: 300px;
    box-shadow: 0 3px 6px #00000029, 0 3px 6px #0000003b;
    flex-shrink: 0;
    z-index: 99;
    display: flex;
    flex-flow: column;
    height: 100%;
    position: relative;
    overflow: hidden;

    .editor-header {
        background-color: white;
        border-bottom: 1px solid #ececec;

        p, 
        .el-dropdown {
            padding: 15px;
            margin: 0px;
            font-weight: 600;
            font-size: 1rem;
        }
        .el-dropdown {
            cursor: pointer;
        }
    }
    .editor-body {
        background-color: white;
        height: calc(100% - 155px);
        overflow: auto;
        padding: 15px;
        
        .el-form-item {
            margin-bottom: 15px;
            .el-form-item__label {
                line-height: 16px;
                font-size: 0.8rem;
                padding: 0px;
            }
        }

        .editor-body-empty {
            margin-top: 40%;
            p {
                color: #d63031;
                text-align: center;
                font-weight: 600;
                margin: 25px 0px;
                font-size: 1.2rem;
            }
            button {
                width: 100%;
                margin: 0px 0px 5px 0px;
            }
        }
    }
    .editor-footer {
        background-color: white;
        padding: 15px;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: flex-end;
        z-index: 2;
        box-shadow: 0px 3px 0px #00000029, 0px 3px 15px #0000003b;
    }
}
</style>